export default __webpack_public_path__ + "static/CAReady_Logo_RGB-4fe4c7d2cc8a00d5a9376953f0970976.png";